import { StorageReference } from '@angular/fire/storage';

export class SetFilesAction {
  public static readonly type = '[Project/Storage/List] SetFilesAction';
  constructor(public readonly files: StorageReference[]) {}
}
